<footer class="row main-footer">
  <div class="col-md-6 pull-left hidden-xs">
    Copyright &copy; 2025-2026 <a href="https://creative123.com" target="_blank">Creative Energies</a>. All rights reserved.
  </div>
  <div class="col-md-6 pull-right hidden-xs">
    <ul class="footer_link">
      <li><a href="#">Home</a></li>

     
    </ul>
  </div>
</footer>
